import type { FC } from "react";
import { Image } from "react-bootstrap";
import Button from "react-bootstrap/Button";

import { Lightbox } from "components/Lightbox";
import { Loading } from "components/Loading";

interface Props {
  isLoading: boolean;
  onClose: () => void;
}

// Nadpis je pod ilustrací záložky, takže zůstává v těle a jen pojmenuje dialog. [TD-344]
const Bookmarked: FC<Props> = ({ isLoading, onClose }) => (
  <Lightbox
    show={true}
    onHide={() => {
      onClose();
    }}
    bodyClassName="pb-40px"
    bodyTitleId="bookmarked-title"
  >
    {isLoading ? (
      <Loading></Loading>
    ) : (
      <>
        <div className="mb-8px text-center">
          <Image src={"/images/bookmark-saved.svg"} />
        </div>
        {/* Velikost drží `.fs-18`, ať se sjednocením na `h2` (globálně 17 px) nezmění
            vzhled — původní `h3` měl 18 px ($h3-font-size). [TD-344] */}
        <h2 id="bookmarked-title" className={"text-center mb-20px fs-18"}>
          Otázku jsme uložili!
        </h2>
        <p className={"text-center mb-20px"}>Najdeš ji v sekci „Uložené úlohy“, ať se k ní kdykoliv můžeš vrátit 🙂 </p>
        <Button
          variant="outline-secondary"
          className={"w-100 text-uppercase"}
          onClick={() => {
            onClose();
          }}
        >
          Zavřít
        </Button>
      </>
    )}
  </Lightbox>
);

export default Bookmarked;
